import { useEffect } from 'react';

import {
    TextField, DialogContentText, Typography
} from '@mui/material';

import { regex_num } from '../../../constants/regex';

const ConfirmForm = ({
    code, setData, interfaceData, setInterfaceData
}) => {
    const { code_field, code_confirmed, code_err, disabled } = interfaceData;

    useEffect(() => {
        setInterfaceData(e => ({
            ...e, code_err: code.length !== 6 ? true : false
        }));
    }, [code]);
    
    const handleOnChange = ({ target }) => {
        const name = target.name;
        const value = target.value;
        if (name === 'code' && code_field) {
            if (value === '' || (value.length <= 6 && regex_num.test(value)))
                setData(e => ({ ...e, code: value }));
        }
    };

    return (
        code_confirmed ?
            <>
                <DialogContentText sx={{ mb: 2 }}>
                    ¿Desea eliminar permanentemente su cuenta?
                    Si procede se eliminará toda su información del sitio, direcciones de envío, direcciones de facturación y sus datos personales.
                </DialogContentText>
                <Typography variant="button" gutterBottom>
                    Tenga en cuenta que tendrá que volver a registrarse en el sitio para ver su lista de pedidos.
                </Typography>
            </>
        :
            <>
                <DialogContentText sx={{ mb: 2 }}>
                    Se ha enviado un código a su correo electrónico.
                    Ingrese el código que recibió para proceder a eliminar su cuenta.
                </DialogContentText>
                <TextField
                    label="Código de acceso"
                    type="code"
                    variant="standard"
                    error={ code_err }
                    helperText={ code_err ? "6 dígitos" : "" }
                    inputProps={{ maxLength: 6 }}
                    name="code"
                    value={ code }
                    onChange={ handleOnChange }
                    disabled={ disabled }
                />
            </>
    );
};

export default ConfirmForm;